export const MAX_OPTION_COUNT = 40_000

// 최대 판매수량 65535 = 레거시의 '최대 판매수량 제한 없음' 표시값 (PM 확인 2026-10-01).
// 상용 하이버 상품의 약 10% 가 이 값이라, 하이버 최대 판매수량 규칙(1000개 이하)은 이 값만 예외로 통과시킨다 —
// 막으면 상품명·가격·옵션 등 다른 칸만 고쳐도 [저장]이 판매정보 검증에서 멈춘다(스테이징 QA, 2026-10-01).
export const MAX_ORDER_QTY_UNLIMITED = 65535

// 하이버 신규 상품 등록/수정 페이지(단일 페이지 + 옵션 편집기 팝업) 활성화 여부
// false 로 두면 하이버 셀러도 기존 Legacy 4-step / v-tabs 페이지 사용
//
// ⚠ 오늘출발 오픈 뒤에는 false 로 내리지 않는다.
//   Legacy 페이지의 판매정보 저장은 admin-api-v3 `PATCH /products/{no}/sales` 로 가는데, v3 는 상품 행을 통째로
//   다시 만들어 저장하면서 배송코드·오늘출발 재고유무를 기본값(01·N)으로 덮는다. 오늘출발 상품이 조용히 꺼진다.
//   v3 는 레거시라 고치지 않는다(adminapi 에만 작업한다). 하이버는 신규 페이지 → adminapi 경로로만 저장해야 안전하다.
export const HIVER_NEW_PRODUCT_PAGE = true

// 하이버 서비스 번호 — 상품 행의 serviceSectionNo(DB TB_C_PRODUCT.C_SRVC_SE_NO)와 adminapi ServiceNo.HIVER 가 같은 값을 쓴다.
// 재고관리 가격·재고 일괄저장에서 이 값인 상품만 adminapi 로 보낸다 (src/utils/productBatchWrite.ts).
export const HIVER_SERVICE_SECTION_NO = 2

export const DELIVERY_TYPE = [
  { title: '국내배송', value: 'DS' },
  { title: '해외배송', value: 'OS' },
]

export const CERTIFICATION_DETAIL_OPTIONS = [
  { title: '안전인증', value: 'CERTIFICATION' },
  { title: '안전확인', value: 'VERIFICATION' },
  { title: '공급자적합성확인', value: 'SUPPLIER_COMPLIANCE' },
]

export const MADEIN_OPTIONS = [
  { title: '상품상세 참조', value: -1 },
  { title: '한국', value: 'KOREA' },
  { title: '중국', value: 'CHINA' },
  { title: '베트남', value: 'VIETNAM' },
  { title: '기타', value: 'NONE' },
]

export const CERTIFICATION_OPTIONS = [
  { title: '상세페이지 참조', value: 'PRODUCT_DETAIL' },
  { title: '인증대상', value: -1 },
  { title: '해당사항 없음', value: 'NONE' },
]
